module.exports = __webpack_public_path__ + "static/media/grpPic.1051688a.jpeg";